module.exports = __webpack_public_path__ + "static/img/9.a10a9b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/zh/9.png
// module id = OhAl
// module chunks = 0